define('customPlugins/atnKendoComboBox',[
        'knockout', 'lodash', 'jquery', 'kendo-knockout',
    ],
    function(ko, _, $) {
        'use strict';
        var inputBoxInitialized;
        ko.bindingHandlers.atnKendoComboBox = {
            init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                ko.bindingHandlers.kendoComboBox.init(element, valueAccessor, allBindings, viewModel, bindingContext);

                var combobox = $(element).data('kendoComboBox');
                var data = valueAccessor().data();
                _.defer(function() {
                    $($(element).prev().children()[0]).on('cut paste blur', onDeferredChange);
                    combobox.bind('select', onSelect);
                });

                function onDeferredChange(e) {
                    _.defer(onChange,e);
                }

                function onChange(e) {
                    var textSelected = $(element).prev().children()[0].value,
                        options = combobox.options;
                    element.value = textSelected;
                    valueAccessor().value(textSelected);
                }

                function onSelect(e){
                    onSelectHandler(e.item.text());
                }
                function onSelectHandler(selectedValue) {
                    if(_.indexOf(data,selectedValue)<data.length-1 && _.indexOf(data,selectedValue)>=0){
                        $($(element).prev().children()[0]).prop("readonly",true);
                    }else{
                        $($(element).prev().children()[0]).prop("readonly",false);
                    }
                    element.value = selectedValue;
                    valueAccessor().value(selectedValue);
                }
            },
            update:function(element, valueAccessor, allBindings, viewModel, bindingContext){
                var data = valueAccessor().data();

                if(bindingContext.$data.isInlineEditEnabled){
                    bindingContext.$data.isInlineEditEnabled.subscribe(function(){
                        if($(element).prev().children()[0]){
                            $(element).prev().children()[0].value = valueAccessor().value();
                        }
                        onSelectHandler(valueAccessor().value());
                    });
                }
                _.defer(function() {
                    $($(element).prev().children()[0]).on('blur', onBoxBlur);
                });
                function onBoxBlur(){
                    $(element).prev().children()[0].value = valueAccessor().value();
                }

                function onSelectHandler(selectedValue) {
                    if(_.indexOf(data,selectedValue)<data.length-1 && _.indexOf(data,selectedValue)>=0){
                        $($(element).prev().children()[0]).prop("readonly",true);
                    }else{
                        $($(element).prev().children()[0]).prop("readonly",false);
                    }
                    element.value = selectedValue;
                    valueAccessor().value(selectedValue);
                }
            }
        };
    });
